import { ReactNode } from 'react';
import { QueryProvider } from './QueryProvider';
import { ThemeProvider } from './ThemeProvider';
import { AppRoutes } from '@/app/routes/AppRoutes';

interface RouterProviderProps {
  children?: ReactNode;
}

export const RouterProvider = ({ children }: RouterProviderProps) => {
  return (
    <ThemeProvider>
      <QueryProvider>
        {children || <AppRoutes />}
      </QueryProvider>
    </ThemeProvider>
  );
};


